export const BASIC_METRICS = [
  'MRR',
  'ARR',
  'Taxa de Churn',
  'LTV',
  'Receita Total',
  'Evolução de Receita',
  'Taxa de Churn (Gráfico)',
] as const;

export const ADVANCED_METRICS = [
  'CAC',
  'Ticket Médio',
  'Churn Detalhado',
  'Previsão de Receita',
  'Métricas de Engajamento',
  'Cohort Analysis',
  'Análise de Retenção',
  'ROI por Canal',
] as const;

export const AVAILABLE_INTEGRATIONS = [
  'Hotmart',
  'Stripe',
  'Mercado Pago',
  'Kiwify',
  'Eduzz',
  'PayPal',
  'PagSeguro',
  'Iugu',
  'Vindi',
  'Pagar.me',
] as const;

export type BasicMetric = typeof BASIC_METRICS[number];
export type AdvancedMetric = typeof ADVANCED_METRICS[number];
export type Integration = typeof AVAILABLE_INTEGRATIONS[number];
